export * from './paginator.component';
export * from './interfaces/prizm-paginator.interface';
export * from './paginator.module';
